import darkColors from './dark'
import lightColors from './light'

const colors = {
    dark: darkColors,
    light: lightColors
}

export default colors
